@if(loading){
<div class="grid resource-grid">
  @for(i of [1,2,3];track i){
  <div class="col">
    <div class="gridcol-header">
      <app-skeleton [id]="'form-fields'" [size]="{height:'2rem'}"></app-skeleton>
    </div>
    <div class="body-row mt-2">
      <p-skeleton height="20rem"></p-skeleton>
    </div>
  </div>
  }
</div>
} @else{
<div class="grid m-0">
    <div class="col p-0 border-right-1 border-200">
     <div class="flex px-3 py-2 surface-100 align-items-center gap-3 ">
      <label for="searchApi">Dashboard</label>
      <p-iconfield class="w-full">
        <p-inputicon> <i-tabler name="search" class="it-normal ti-base"></i-tabler></p-inputicon>
        <input type="text" class="w-full" pInputText placeholder="Search for Dashboard" [(ngModel)]="searchDashboard"  />
      </p-iconfield>
    </div>
   
    <div class="body-row p-3">
      <ng-container
        *ngIf="resourcesData && resourcesData['Dashboards'] && (resourcesData['Dashboards'] | searchFilter:searchDashboard:'resourceName').length > 0; else noDashboardsDataTemplate">
        <div class="flex my-3 gap-3" *ngIf="resourcesData['Dashboards']?.length > 0 && !disabled">

          <p-button label="Select All" size="small" [outlined]="true" severity="secondary"
            (onClick)="selectAll('Dashboards',searchDashboard)" />
          <p-button label="Clear All" size="small" [outlined]="true" severity="secondary"
            (onClick)="clearAll('Dashboards',searchDashboard)" />
        </div>
        <div class="flex flex-wrap gap-2 max-h-20rem overflow-y-auto">
          <ng-container
            *ngFor="let item of resourcesData['Dashboards'] | searchFilter:searchDashboard:'resourceName' let i = index;let even = even">
            <p-button [disabled]="disabled" [title]="item.resourceName" (onClick)="checkBoxCommon('Dashboards', item)"
              [outlined]="!item.isAssigned" size="small">
              <span>{{item.resourceName | titlecase}} ({{actionNameMapping[item.resourceActionName]}})</span>
            </p-button>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #noDashboardsDataTemplate>
        <div class="flex justify-content-center align-items-center py-4">
          No Dashboards to display
        </div>
      </ng-template>
    </div>

  </div>

  <div class="col p-0">

     <div class="flex px-3 py-2 surface-100 align-items-center gap-3 ">
      <label for="searchApi">Widget</label>
      <p-iconfield class="w-full">
        <p-inputicon> <i-tabler name="search" class="it-normal ti-base"></i-tabler></p-inputicon>
        <input type="text" class="w-full" pInputText placeholder="Search for Widget" [(ngModel)]="searchWidget"  />
      </p-iconfield>
    </div>

    <div class="body-row p-3">
      <ng-container
        *ngIf="resourcesData && resourcesData['Widgets'] && (resourcesData['Widgets'] | searchFilter:searchWidget:'resourceName').length > 0; else noWidgetsDataTemplate">
        <div class="flex my-3 gap-3" *ngIf="resourcesData['Widgets']?.length > 0 && !disabled">

          <p-button label="Select All" size="small" [outlined]="true" severity="secondary"
            (onClick)="selectAll('Widgets',searchWidget)" />
          <p-button label="Clear All" size="small" [outlined]="true" severity="secondary"
            (onClick)="clearAll('Widgets',searchWidget)" />
        </div>


        <div class="flex flex-wrap gap-2 max-h-20rem overflow-y-auto">
          <ng-container
            *ngFor="let item of resourcesData['Widgets'] | searchFilter:searchWidget:'resourceName' let i = index;let even = even">
            <p-button [disabled]="disabled" [title]="item.resourceName" (onClick)="checkBoxCommon('Widgets', item)"
              [outlined]="!item.isAssigned" size="small">
              <span>{{item.resourceName | titlecase}} ({{actionNameMapping[item.resourceActionName]}})</span>
            </p-button>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #noWidgetsDataTemplate>
        <div class="flex justify-content-center align-items-center py-4">
          No Widgets to display
        </div>
      </ng-template>
    </div>
  </div>
  <div class="col p-0 border-right-1 border-200">
    <div class="flex px-3 py-2 surface-100 align-items-center gap-3 ">
      <label for="searchApi">API's</label>
      <p-iconfield class="w-full">
        <p-inputicon> <i-tabler name="search" class="it-normal ti-base"></i-tabler></p-inputicon>
        <input type="text" class="w-full" pInputText placeholder="Search for API" [(ngModel)]="searchApi"  />
      </p-iconfield>
    </div>
    <div class="body-row p-3">
      <ng-container
        *ngIf="resourcesData && resourcesData['APIs'] && (resourcesData['APIs'] | searchFilter:searchApi:'resourceName').length > 0; else noAPIsDataTemplate">
        <div class="flex my-3 gap-3" *ngIf="resourcesData['APIs']?.length > 0 && !disabled">

          <p-button label="Select All" size="small" [outlined]="true" severity="secondary"
            (onClick)="selectAll('APIs',searchApi)" />
          <p-button label="Clear All" size="small" [outlined]="true" severity="secondary"
            (onClick)="clearAll('APIs',searchApi)" />
        </div>
        <div class="flex flex-wrap gap-2 max-h-20rem overflow-y-auto">
          <ng-container
            *ngFor="let item of resourcesData['APIs'] | searchFilter:searchApi:'resourceName' let i = index;let even = even">
            <p-button [disabled]="disabled" [title]="item.resourceName" (onClick)="checkBoxCommon('APIs', item)"
              [outlined]="!item.isAssigned" size="small">
              <span>{{item.resourceName | titlecase}} ({{actionNameMapping[item.resourceActionName] }}) </span>
            </p-button>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #noAPIsDataTemplate>
        <div class="flex justify-content-center align-items-center py-4">
          No APIs to display
        </div>
      </ng-template>

    </div>
  </div>


</div>
}